import { ButtonWithRef } from '@belong/ui-components/components/actions/Button';

import { CloseButtonWrapper } from './ChatFeedback.styles';
import CONTENT from '../content.json';

type CloseButtonProps = Pick<React.ComponentProps<typeof ButtonWithRef>, 'onClick'>;

export const FeedbackCloseButton: React.FC<CloseButtonProps> = ({ onClick }) => {
  return (
    <CloseButtonWrapper>
      <ButtonWithRef onClick={onClick} variant="quaternary">
        {CONTENT.feedback.closeButton}
      </ButtonWithRef>
    </CloseButtonWrapper>
  );
};
